module.exports = __webpack_public_path__ + "a9edfb195b27ee6b67d3fcd027b8011d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/bespoke_bg@2x.jpg
// module id = 657
// module chunks = 0